// axios
import axios from 'axios'

 const baseURL = "https://filledyou.com:7770"

 // const baseURL = "http://210.91.108.121"
 // const baseURL = "http://192.168.204.174:7770"
// const baseURL = "http://192.168.2.103:7770"
// const baseURL = "http://192.168.159.129:7770"
// const baseURL = "https://222.239.249.215:7770"
// const baseURL = "https://filledyou.com:8128"
// const baseURL = "http://211.53.129.38:5001"
// const baseURL = "http://211.53.129.38:7770"
export default axios.create({
  baseURL: baseURL
  // You can add your headers here
})
